// extracted by mini-css-extract-plugin
export default {"search-form":"Y_Qs flex-grow-1 form-group mb-0"};